import { mergeMap } from 'rxjs/operators';
import { IEpic, isTypeOfAndGetPayload } from '@cbridge-utils/redux-observable';
import { IClientApiDependencySegment, catchApiError } from '@cbridge-packages/api';
import { createApiErrorNotification } from '@cbridge-packages/notification';
import { ScheduleAction } from '../schedule.action';
import { ScheduleTranslator } from '../schedule.translator';

type IDependencies = IClientApiDependencySegment;

export const loadScheduleEpic: IEpic<{}, IDependencies> = (action$, _, dependencies) => action$.pipe(
  isTypeOfAndGetPayload(ScheduleAction.load.started),
  mergeMap((params) => {
    const { scheduleId } = params;

    return dependencies.api.getScheduleDetails({ scheduleId }).pipe(
      mergeMap((response) => {
        return [
          ScheduleAction.load.done({ params, result: ScheduleTranslator.fromApiDetails(response) }),
        ];
      }),
      catchApiError((error) => {
        return [
          ScheduleAction.load.failed({ params, error }),
          createApiErrorNotification(error),
        ];
      }),
    );
  }),
);
